<!-- <ion-header>
  <ion-navbar>
  </ion-navbar>
</ion-header> -->
<ion-header>
    <ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
  <container-with-items [container]="container" [type]="'Events'"></container-with-items>
  <ion-infinite-scroll (ionInfinite)="loadNextPage($event)" [disabled]="!hasMoreItems">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'GLOBAL_SEARCH_LOADING_MORE' | translate }}">
      </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>